import * as React from 'react';

import { ButtonTheme, ButtonThemeType, IStyleConfig, mergeStyles } from '@cian/components';

import { formatPhone } from '../../../../utils/format_phone';
import RevealContent from '../reveal_content/reveal_content';

const styles = require('./object_phone_show.css');

export interface IObjectPhoneShowProps {
  phones: string[];
  theme?: ButtonThemeType;
  buttonStyle?: IStyleConfig;
  phoneListStyle?: IStyleConfig;
  phoneStyle?: IStyleConfig;
  onPhoneShow?: (phones: string[]) => void;
}

const ObjectPhoneShow: React.StatelessComponent<IObjectPhoneShowProps> = (props) => {
  return (
    props.phones.length && <RevealContent
      buttonLabel={`Показать ${props.phones.length > 1 ? 'телефоны' : 'телефон'}`}
      buttonTheme={props.theme}
      buttonStyle={props.buttonStyle}
      hiddenContent={
        <div {...mergeStyles(styles['phones'], props.phoneListStyle)}>{props.phones.map((phoneNumber, index) =>
          <span key={phoneNumber}>
            <a href={`tel:${phoneNumber}`} {...mergeStyles(props.phoneStyle, styles['phone-link'])}>
              {formatPhone(phoneNumber)}
            </a>
            {(index !== props.phones.length - 1) && ', '}
          </span>
        )}</div>
      }
      onRevealed={props.onPhoneShow && (() =>  props.onPhoneShow(props.phones))}
    />);
};

ObjectPhoneShow.defaultProps = {
  phones: [],
  theme: ButtonTheme.BLUE_SOLID,
};

export default ObjectPhoneShow;



// WEBPACK FOOTER //
// ./src/bundles/common/components/object_phone_show/object_phone_show.tsx